module.exports = __webpack_public_path__ + "img/img12.98e72e2d.svg";